const Event = {

    // PAGE HEADER
    "event": "Event",
    "calendarTitle": "Event Calendar",
    "calendarSubtitle": "View events by month and open details from the calendar.",
    "no_events_month": "No events scheduled for this month.",
    "event_details": "Event Details",

    // FIELDS
    "premise": "Premise",
    "title": "Event Title",
    "description": "Description",
    "start_date": "Start Date",
    "end_date": "End Date",
    "start_time": "Start Time",
    "end_time": "End Time",
    "venue": "Venue",
    "max_capacity": "Maximum Capacity",
    "banner": "Banner / Image",
    "rsvp_required": "RSVP Required",
    "rsvp_deadline": "RSVP Deadline",
    "rsvp_responses": "RSVP Responses",
    "rsvp_going": "Going",
    "rsvp_not_going": "Not Going",
    "rsvp_maybe": "Maybe",
    "rsvp_list": "RSVP List",
    "no_rsvp": "No RSVP Responses Yet.",
    "status": "Status",
    "search": "Search",
    "yes": "Yes",
    "no": "No",
    "created_at": "Created At",
    "event_date": "Event Date",
    "event_time": "Event Time",
    "no_description": "No description provided.",
    "no_banner": "No banner uploaded.",
    "load_error": "Something went wrong. Unable to load event details.",
    "your_rsvp": "Your RSVP",
    "rsvp_deadline_expired": "RSVP deadline has expired.",
    "rsvp_success": "RSVP Submitted Successfully.",
    "rsvp_update_success": "RSVP Updated Successfully.",

    // STATUS LABELS
    "status_upcoming": "Upcoming",
    "status_ongoing": "Ongoing",
    "status_completed": "Completed",

    // TABLE HEADERS
    "table_title": "TITLE",
    "table_premise": "PREMISE",
    "table_banner": "BANNER",
    "table_event_date": "EVENT DATE",
    "table_event_time": "EVENT TIME",
    "table_venue": "VENUE",
    "table_capacity": "CAPACITY",
    "table_rsvp": "RSVP",
    "table_rsvp_deadline": "RSVP DEADLINE",
    "table_status": "STATUS",

    // ERRORS
    "error_premise": "Select Premise",
    "error_title": "Enter Event Title",
    "error_description": "Enter Description",
    "error_start_date": "Select Event Start Date",
    "error_end_date": "Select Event End Date",
    "error_end_date_before_start": "Event End Date cannot be earlier than Event Start Date",
    "error_start_time": "Select Start Time",
    "error_end_time": "Select End Time",
    "error_end_time_before_start": "End Time cannot be earlier than Start Time on the same day",
    "error_venue": "Enter Venue",
    "error_max_capacity": "Enter Maximum Capacity",
    "error_max_capacity_min": "Maximum Capacity must be at least 1",
    "error_rsvp_deadline": "Select RSVP Deadline",
    "error_rsvp_deadline_after_start": "RSVP Deadline cannot be later than the Event Start Date",

}

export default Event;